import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSharesEquity,
  setIncomeAssets,
  setCashAccounts,
  setEstateValue,
  setGoldJewelry,
  setOtherAssets,
  setHomeLoans,
  setOtherLoans,
  setBillsPayments,
  setCreditCardDues,
  setOtherLiabilities,
  setNetWorth,
  setIncomeTaxLonas,
  resetNetworthData,
  setTotalAssets,
  setTotalLiabilities,
} from "../redux/calculations/networthSlice";
import {
  resetChartData,
  updatedNetWorthChart,
} from "../redux/calculations/calculaterSlice";
import CalculatorLayout from "../components/CalcLayout";
import Input from "../components/Input";
import { Button } from "../components/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import useLocale from "../../src/locales/index";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import i18n from "../i18n";
import { Helmet } from "react-helmet";

const NetWorthcalc = () => {
  const dispatch = useDispatch();
  const {
    sharesEquity,
    incomeAssets,
    cashAccounts,
    estateValue,
    goldJewelry,
    otherAssets,
    homeLoans,
    otherLoans,
    billsPayments,
    creditCardDues,
    otherLiabilities,
    incomeTaxLonas,
  } = useSelector((state) => state.networthCalculator);
  const { textData } = useLocale();
  const { netWorthCalc } = textData;
  const cAccept = localStorage.getItem("grow-cookies");
  const cookieAccept = JSON.parse(cAccept);
  const [calcDone, setCalcDone] = useState(false);
  const formik = useFormik({
    initialValues: {
      sharesEquity: sharesEquity,
      incomeAssets: incomeAssets,
      cashAccounts: cashAccounts,
      estateValue: estateValue,
      goldJewelry: goldJewelry,
      otherAssets: otherAssets,
      homeLoans: homeLoans,
      otherLoans: otherLoans,
      incomeTaxLonas: incomeTaxLonas,
      billsPayments: billsPayments,
      creditCardDues: creditCardDues,
      otherLiabilities: otherLiabilities,
    },
    validationSchema: Yup.object({
      sharesEquity: Yup.number()
        .required(netWorthCalc.sharesEquityRequired)
        .min(0, netWorthCalc.sharesEquityMin)
        .max(5000000, netWorthCalc.sharesEquityMax),
      incomeAssets: Yup.number()
        .required(netWorthCalc.incomeAssetsRequired)
        .min(0, netWorthCalc.incomeAssetsMin)
        .max(1000000, netWorthCalc.incomeAssetsMax),
      cashAccounts: Yup.number()
        .required(netWorthCalc.cashAccountsRequired)
        .min(0, netWorthCalc.cashAccountsMin)
        .max(2500000, netWorthCalc.cashAccountsMax),
      estateValue: Yup.number()
        .required(netWorthCalc.estateValueRequired)
        .min(0, netWorthCalc.estateValueMin)
        .max(30000000, netWorthCalc.estateValueMax),
      goldJewelry: Yup.number()
        .required(netWorthCalc.goldJewelryRequired)
        .min(0, netWorthCalc.goldJewelryMin)
        .max(2000000, netWorthCalc.goldJewelryMax),
      otherAssets: Yup.number()
        .required(netWorthCalc.otherAssetsRequired)
        .min(0, netWorthCalc.otherAssetsMin)
        .max(2500000, netWorthCalc.otherAssetsMax),
      homeLoans: Yup.number()
        .required(netWorthCalc.homeLoansRequired)
        .min(0, netWorthCalc.homeLoansMin)
        .max(20000000, netWorthCalc.homeLoansMax),
      otherLoans: Yup.number()
        .required(netWorthCalc.otherLoansRequired)
        .min(0, netWorthCalc.otherLoansMin)
        .max(5000000, netWorthCalc.otherLoansMax),
      incomeTaxLonas: Yup.number()
        .required(netWorthCalc.incomeTaxLonasRequired)
        .min(0, netWorthCalc.incomeTaxLonasMin)
        .max(1000000, netWorthCalc.incomeTaxLonasMax),
      billsPayments: Yup.number()
        .required(netWorthCalc.billsPaymentsRequired)
        .min(0, netWorthCalc.billsPaymentsMin)
        .max(200000, netWorthCalc.billsPaymentsMax),
      creditCardDues: Yup.number()
        .required(netWorthCalc.creditCardDuesRequired)
        .min(0, netWorthCalc.creditCardDuesMin)
        .max(1000000, netWorthCalc.creditCardDuesMax),
      otherLiabilities: Yup.number()
        .required(netWorthCalc.otherLiabilitiesRequired)
        .min(0, netWorthCalc.otherLiabilitiesMin)
        .max(2000000, netWorthCalc.otherLiabilitiesMax),
    }),
    validateOnChange: true,
    validateOnBlur: true,

    onSubmit: (values) => {
      if (cookieAccept && analytics) {
        logEvent(analytics, "calculate_NETWORTH");
      }
      const totalAssets =
        Number(values.sharesEquity) +
        Number(values.incomeAssets) +
        Number(values.cashAccounts) +
        Number(values.estateValue) +
        Number(values.goldJewelry) +
        Number(values.otherAssets);

      const totalLiabilities =
        Number(values.homeLoans) +
        Number(values.otherLoans) +
        Number(values.incomeTaxLonas) +
        Number(values.billsPayments) +
        Number(values.creditCardDues) +
        Number(values.otherLiabilities);

      const networthValue = totalAssets - totalLiabilities;

      dispatch(setSharesEquity(values.sharesEquity));
      dispatch(setIncomeAssets(values.incomeAssets));
      dispatch(setCashAccounts(values.cashAccounts));
      dispatch(setEstateValue(values.estateValue));
      dispatch(setGoldJewelry(values.goldJewelry));
      dispatch(setOtherAssets(values.otherAssets));
      dispatch(setHomeLoans(values.homeLoans));
      dispatch(setOtherLoans(values.otherLoans));
      dispatch(setIncomeTaxLonas(values.incomeTaxLonas));
      dispatch(setBillsPayments(values.billsPayments));
      dispatch(setCreditCardDues(values.creditCardDues));
      dispatch(setOtherLiabilities(values.otherLiabilities));
      dispatch(setNetWorth(networthValue));
      dispatch(setTotalAssets(totalAssets));
      dispatch(setTotalLiabilities(totalLiabilities));
      dispatch(
        updatedNetWorthChart({
          totalAssets: totalAssets,
          totalLiabilities: totalLiabilities,
          netWorth: networthValue,
        })
      );
      setCalcDone(true);
      scrollToResult();
    },
  });
  useEffect(() => {
    return () => {
      dispatch(resetChartData());
      dispatch(resetNetworthData());
    };
  }, [dispatch]);

  const formatToINR = (value) => {
    if (value === "" || value === null || value === undefined) return "";
    if (value === 0) return "0";

    const shouldForceIndianFormat = i18n.language === "fa";

    return isNaN(Number(value))
      ? ""
      : Number(value).toLocaleString(
        shouldForceIndianFormat ? "en-IN" : i18n.language || "en-IN"
      );
  };

  const parseINRInput = (value) => {
    return value.replace(/[^0-9]/g, "");
  };

  // References for sliders
  const sharesSliderRef = useRef(null);
  const incomeSliderRef = useRef(null);
  const cashSliderRef = useRef(null);
  const estateSliderRef = useRef(null);
  const goldSliderRef = useRef(null);
  const otherAssetsSliderRef = useRef(null);
  const homeLoansSliderRef = useRef(null);
  const otherLoansSliderRef = useRef(null);
  const incomeTaxLonasSliderRef = useRef(null);
  const billsSliderRef = useRef(null);
  const creditCardSliderRef = useRef(null);
  const otherLiabilitiesSliderRef = useRef(null);
  const resultRef = useRef(null);


  // Slider change handlers
  const handleSharesEquityChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setSharesEquity(value));
    formik.setFieldValue("sharesEquity", value);
    setCalcDone(false);
  };

  const handleIncomeAssetsChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setIncomeAssets(value));
    formik.setFieldValue("incomeAssets", value);
    setCalcDone(false);
  };

  const handleCashAccountsChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setCashAccounts(value));
    formik.setFieldValue("cashAccounts", value);
    setCalcDone(false);
  };

  const handleEstateValueChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setEstateValue(value));
    formik.setFieldValue("estateValue", value);
    setCalcDone(false);
  };

  const handleGoldJewelryChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setGoldJewelry(value));
    formik.setFieldValue("goldJewelry", value);
    setCalcDone(false);
  };

  const handleOtherAssetsChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setOtherAssets(value));
    formik.setFieldValue("otherAssets", value);
    setCalcDone(false);
  };

  const handleHomeLoansChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setHomeLoans(value));
    formik.setFieldValue("homeLoans", value);
    setCalcDone(false);
  };

  const handleOtherLoansChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setOtherLoans(value));
    formik.setFieldValue("otherLoans", value);
    setCalcDone(false);
  };
  const handleIncomeTaxLonasChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setIncomeTaxLonas(value));
    formik.setFieldValue("incomeTaxLonas", value);
    setCalcDone(false);
  };

  const handleBillsPaymentsChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setBillsPayments(value));
    formik.setFieldValue("billsPayments", value);
    setCalcDone(false);
  };

  const handleCreditCardDuesChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setCreditCardDues(value));
    formik.setFieldValue("creditCardDues", value);
    setCalcDone(false);
  };

  const handleOtherLiabilitiesChange = (e) => {
    const value = Number(e.target.value);
    dispatch(setOtherLiabilities(value));
    formik.setFieldValue("otherLiabilities", value);
    setCalcDone(false);
  };

  const handleSharesChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("sharesEquity", "");
      return;
    }
    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("sharesEquity", 0);
      return;
    }
    formik.setFieldValue("sharesEquity", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };

  const handleIncomeChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("incomeAssets", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("incomeAssets", 0);
      return;
    }

    formik.setFieldValue("incomeAssets", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };

  const handleCashChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("cashAccounts", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("cashAccounts", 0);
      return;
    }

    formik.setFieldValue("cashAccounts", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handleEstateChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("estateValue", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("estateValue", 0);
      return;
    }

    formik.setFieldValue("estateValue", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };

  const handleIncomeTaxLoanChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("incomeTaxLonas", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("incomeTaxLonas", 0);
      return;
    }

    formik.setFieldValue("incomeTaxLonas", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };

  const handleGoldChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("goldJewelry", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("goldJewelry", 0);
      return;
    }

    formik.setFieldValue("goldJewelry", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handlOtherChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("otherAssets", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("otherAssets", 0);
      return;
    }

    formik.setFieldValue("otherAssets", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handleHomloanChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("homeLoans", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("homeLoans", 0);
      return;
    }

    formik.setFieldValue("homeLoans", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handleOtherLoanChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("otherLoans", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("otherLoans", 0);
      return;
    }

    formik.setFieldValue("otherLoans", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handleBillChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("billsPayments", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("billsPayments", 0);
      return;
    }

    formik.setFieldValue("billsPayments", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handleCreditChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("creditCardDues", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("creditCardDues", 0);
      return;
    }

    formik.setFieldValue("creditCardDues", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const handleLiabilitiesChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      formik.setFieldValue("otherLiabilities", "");
      return;
    }

    const rawValue = inputValue.replace(/[^0-9]/g, "");
    if (rawValue.length > 8) return;

    if (rawValue === "0") {
      formik.setFieldValue("otherLiabilities", 0);
      return;
    }

    formik.setFieldValue("otherLiabilities", rawValue ? Number(rawValue) : "");
    setCalcDone(false);
  };
  const isRTL = () => {
    const rtlLanguages = ["ar", "fa", "ur"];
    return rtlLanguages.includes(i18n.language);
  };

  const scrollToResult = () => {
    resultRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const descriptionContent = (
    <div className="p-4 sm:p-5 w-full bg-[#F6F8FB] rounded-xl">
      <h2 className="text-black text-base sm:text-xl font-medium">
        {" "}
        {textData.netWorthContent.title}
      </h2>
      <p className="leading-relaxed mt-2  text-sm sm:text-[15px]">
        {textData.netWorthContent.description}
      </p>
      <h2 className="text-black text-base sm:text-xl font-medium mt-5">
        {" "}
        {textData.netWorthContent.howItWorksTitle}
      </h2>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.netWorthContent.howItWorksDescription}
      </p>
      <p className="font-medium bg-[#E0E4F0] text-sm sm:text-base p-3 mt-3">
        {textData.netWorthContent.formula}
      </p>

      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {" "}
        {textData.netWorthContent.formulaDec}
      </p>

      <h3 class="text-2xl text-gray-800 mt-6">
        {" "}
        {textData.netWorthContent.breakDown}
      </h3>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {" "}
        {textData.netWorthContent.breckdownDec}
      </p>
      <p className="leading-relaxed mt-3 text-sm sm:text-[15px]">
        {textData.netWorthContent.exFormula}
      </p>

      <h3 className="text-black text-base sm:text-xl font-medium mt-5">
        {" "}
        {textData.netWorthContent.assetTypesTitle}
      </h3>
      <table className="border-collapse mt-4 w-full">
        <tbody>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[0].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[0].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[1].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[1].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[2].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[2].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[3].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[3].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[4].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[4].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[5].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.assetTypesTable[5].examples}
            </td>
          </tr>
        </tbody>
      </table>
      <h3 className="text-black text-base sm:text-xl font-medium mt-5">
        {" "}
        {textData.netWorthContent.liabilityTypesTitle}
      </h3>
      <table className="border-collapse mt-4 w-full">
        <tbody>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[0].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[0].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[1].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[1].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[2].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[2].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[3].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[3].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[4].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[4].examples}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[5].type}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.netWorthContent.liabilityTypesTable[5].examples}
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-black text-base sm:text-xl font-medium mt-5">
        {textData.netWorthContent.benifit}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>{textData.netWorthContent.benifitDec[0]}</li>
        <li>{textData.netWorthContent.benifitDec[1]}</li>
        <li>{textData.netWorthContent.benifitDec[2]}</li>
        <li>{textData.netWorthContent.benifitDec[3]}</li>
        <li>{textData.netWorthContent.benifitDec[4]}</li>
      </ul>

      <h3 className="text-black text-base sm:text-xl font-medium mt-5">
        {textData.netWorthContent.networth}
      </h3>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong>{textData.netWorthContent.networthDec[0].value}</strong>{" "}
          {textData.netWorthContent.networthDec[0].dec}
        </li>
        <li>
          <strong>{textData.netWorthContent.networthDec[1].value}</strong>{" "}
          {textData.netWorthContent.networthDec[1].dec}
        </li>
      </ul>

      <h3 className="text-black text-base sm:text-xl font-medium mt-5">
        {" "}
        {textData.netWorthContent.exampleCalculationTitle}
      </h3>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.netWorthContent.exampleCalculationStep1}
      </p>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.netWorthContent.exampleCalculationStep2}
      </p>
      <h4 class="text-xl text-gray-800 mt-6">
        {textData.netWorthContent.descaimber}
      </h4>
      <p class="leading-6 mt-2">{textData.netWorthContent.dec}</p>
    </div>
  );
  const getFormattedPlaceholder = (language) => {
    const baseValue = 10000;
    const formatLang = language === "fa" ? "en-IN" : language;
    return new Intl.NumberFormat(formatLang).format(baseValue);
  };
  return (
    <>
      <Helmet>
        <title>What’s My Net Worth? - Use Our Free Net Worth Calculator</title>
        <meta
          name="description"
          content="What's your real net worth? Use our Free Online Personal Net Worth Calculator to check your net wealth instantly and track your financial growth smartly."
        />
        <link
          rel="canonical"
          href="https://growlifefund.com/calculator/net-worth-calculator"
        />

        <meta
          property="og:title"
          content="What’s My Net Worth? - Use Our Free Net Worth Calculator"
        />
        <meta
          property="og:description"
          content="What's your real net worth? Use our Free Online Personal Net Worth Calculator to check your net wealth instantly and track your financial growth smartly."
        />
        <meta
          property="og:url"
          content="https://growlifefund.com/calculator/net-worth-calculator"
        />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Know Your Wealth by Online Personal Net Worth Calculator"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <CalculatorLayout
        calcDone={calcDone}
        title={
          <>
            {" "}
            <span className="text-black lg:text-xl sm:text-lg text-lg">
              {textData.your}{" "}
            </span>
            {textData.netWorthCalc.title}
          </>
        }
        description={textData.netWorthCalc.description}
        descriptionContent={descriptionContent}
      >
        <div className="" ref={resultRef}>
          <form onSubmit={formik.handleSubmit} noValidate className="flex flex-col gap-6">
            <h2 className="font-bold text-base sm:text-base text-black pb-6 text-start">
              {textData.netWorthCalc.assetsTitle}
            </h2>

            {/* Shares and Equity */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.sharesEquityLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={sharesSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={5000000}
                    step={1000}
                    value={formik.values.sharesEquity}
                    onChange={handleSharesEquityChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.sharesEquity - 0) / (5000000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>
                <div className="flex items-end flex-col">
                  <Input
                    name="sharesEquity"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.sharesEquity)}
                    onChange={handleSharesChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.sharesEquity && formik.errors.sharesEquity
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.sharesEquity && formik.errors.sharesEquity
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.sharesEquity &&
                    formik.errors.sharesEquity && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.sharesEquity}
                      </div>
                    )}
                </div>
              </div>
            </div>
            {/* Income Assets */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.incomeAssetsLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={incomeSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={1000000}
                    step={1000}
                    value={formik.values.incomeAssets}
                    onChange={handleIncomeAssetsChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.incomeAssets - 0) / (1000000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="incomeAssets"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.incomeAssets)}
                    onChange={handleIncomeChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.incomeAssets && formik.errors.incomeAssets
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.incomeAssets && formik.errors.incomeAssets
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.incomeAssets &&
                    formik.errors.incomeAssets && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.incomeAssets}
                      </div>
                    )}
                </div>
              </div>
            </div>

            {/* Cash and Bank Accounts */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.cashAccountsLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={cashSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={2500000}
                    step={1000}
                    value={formik.values.cashAccounts}
                    onChange={handleCashAccountsChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.cashAccounts - 0) / (2500000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="cashAccounts"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.cashAccounts)}
                    onChange={handleCashChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.cashAccounts && formik.errors.cashAccounts
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.cashAccounts && formik.errors.cashAccounts
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.cashAccounts &&
                    formik.errors.cashAccounts && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.cashAccounts}
                      </div>
                    )}
                </div>
              </div>
            </div>

            {/* Estate Value */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.estateValueLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={estateSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={30000000}
                    step={1000}
                    value={formik.values.estateValue}
                    onChange={handleEstateValueChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.estateValue - 0) / (30000000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="estateValue"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.estateValue)}
                    onChange={handleEstateChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.estateValue && formik.errors.estateValue
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.estateValue && formik.errors.estateValue
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.estateValue && formik.errors.estateValue && (
                    <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                      {formik.errors.estateValue}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Gold and Jewelry */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.goldJewelryLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={goldSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={2000000}
                    step={1000}
                    value={formik.values.goldJewelry}
                    onChange={handleGoldJewelryChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.goldJewelry - 0) / (2000000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="goldJewelry"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.goldJewelry)}
                    onChange={handleGoldChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.goldJewelry && formik.errors.goldJewelry
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.goldJewelry && formik.errors.goldJewelry
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.goldJewelry && formik.errors.goldJewelry && (
                    <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                      {formik.errors.goldJewelry}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Other Assets */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.otherAssetsLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={otherAssetsSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={2500000}
                    step={1000}
                    value={formik.values.otherAssets}
                    onChange={handleOtherAssetsChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.otherAssets - 0) / (2500000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>
                <div className="flex items-end flex-col">
                  <Input
                    name="otherAssets"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.otherAssets)}
                    onChange={handlOtherChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.otherAssets && formik.errors.otherAssets
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.otherAssets && formik.errors.otherAssets
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.otherAssets && formik.errors.otherAssets && (
                    <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                      {formik.errors.otherAssets}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Liabilities Section */}
            <h2 className="font-bold text-black text-base pb-5 text-start">
              {textData.netWorthCalc.liabilitiesTitle}
            </h2>

            {/* Home Loans */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.homeLoansLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={homeLoansSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={20000000}
                    step={1000}
                    value={formik.values.homeLoans}
                    onChange={handleHomeLoansChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.homeLoans - 0) / (20000000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="homeLoans"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.homeLoans)}
                    onChange={handleHomloanChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.homeLoans && formik.errors.homeLoans
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.homeLoans && formik.errors.homeLoans
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.homeLoans && formik.errors.homeLoans && (
                    <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                      {formik.errors.homeLoans}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Other Loans */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.otherLoansLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={otherLoansSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={5000000}
                    step={1000}
                    value={formik.values.otherLoans}
                    onChange={handleOtherLoansChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.otherLoans - 0) / (5000000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>
                <div className="flex items-end flex-col">
                  <Input
                    name="otherLoans"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.otherLoans)}
                    onChange={handleOtherLoanChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.otherLoans && formik.errors.otherLoans
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.otherLoans && formik.errors.otherLoans
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.otherLoans && formik.errors.otherLoans && (
                    <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                      {formik.errors.otherLoans}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Income Tax Owned */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.incomeTaxLonasLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div
                  className="relative   w-full "
                  ref={incomeTaxLonasSliderRef}
                >

                  <input
                    type="range"
                    min={0}
                    max={1000000}
                    step={1000}
                    value={formik.values.incomeTaxLonas}
                    onChange={handleIncomeTaxLonasChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.incomeTaxLonas - 0) / (1000000 - 0)) *
                        100
                        }%`,
                    }}
                  />
                </div>
                <div className="flex items-end flex-col">
                  <Input
                    name="incomeTaxLonas"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.incomeTaxLonas)}
                    onChange={handleIncomeTaxLoanChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.incomeTaxLonas &&
                        formik.errors.incomeTaxLonas
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.incomeTaxLonas &&
                      formik.errors.incomeTaxLonas
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.incomeTaxLonas &&
                    formik.errors.incomeTaxLonas && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.incomeTaxLonas}
                      </div>
                    )}
                </div>
              </div>
            </div>
            {/* Outstanding Bills/Payments */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.billsPaymentsLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={billsSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={200000}
                    step={1000}
                    value={formik.values.billsPayments}
                    onChange={handleBillsPaymentsChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.billsPayments - 0) / (200000 - 0)) * 100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="billsPayments"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.billsPayments)}
                    onBlur={formik.handleBlur}
                    onChange={handleBillChange}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.billsPayments &&
                        formik.errors.billsPayments
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.billsPayments &&
                      formik.errors.billsPayments
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.billsPayments &&
                    formik.errors.billsPayments && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.billsPayments}
                      </div>
                    )}
                </div>
              </div>
            </div>

            {/* Credit Cards dues */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.creditCardDuesLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div className="relative   w-full " ref={creditCardSliderRef}>

                  <input
                    type="range"
                    min={0}
                    max={1000000}
                    step={1000}
                    value={formik.values.creditCardDues}
                    onChange={handleCreditCardDuesChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.creditCardDues - 0) / (1000000 - 0)) *
                        100
                        }%`,
                    }}
                  />
                </div>{" "}
                <div className="flex items-end flex-col">
                  <Input
                    name="creditCardDues"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.creditCardDues)}
                    onChange={handleCreditChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.creditCardDues &&
                        formik.errors.creditCardDues
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.creditCardDues &&
                      formik.errors.creditCardDues
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.creditCardDues &&
                    formik.errors.creditCardDues && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.creditCardDues}
                      </div>
                    )}
                </div>
              </div>
            </div>
            {/* Other Liabilities */}
            <div>
              <div className="flex justify-between items-center mb-2 gap-4">
                <label className="text-start font-normal md:text-sm text-black sm:text-sm text-sm">
                  {textData.netWorthCalc.otherLiabilitiesLabel}
                </label>
              </div>
              <div className="flex justify-between gap-5 items-center">
                <div
                  className="relative   w-full "
                  ref={otherLiabilitiesSliderRef}
                >

                  <input
                    type="range"
                    min={0}
                    max={2000000}
                    step={1000}
                    value={formik.values.otherLiabilities}
                    onChange={handleOtherLiabilitiesChange}
                    className="flex-1 min-w-0 max-w-[314px]"
                    style={{
                      width: "100%",
                      appearance: "none",
                      background: "transparent",
                      ...(isRTL() && {
                        direction: "ltr",
                      }),
                      "--val": `${((formik.values.otherLiabilities - 0) / (2000000 - 0)) *
                        100
                        }%`,
                    }}
                  />
                </div>
                <div className="flex items-end flex-col">
                  <Input
                    name="otherLiabilities"
                    leftIcon={textData.currency}
                    value={formatToINR(formik.values.otherLiabilities)}
                    onChange={handleLiabilitiesChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    dir="ltr"
                    placeholder={getFormattedPlaceholder(10000, i18n.language)}
                    borderColor={
                      formik.touched.otherLiabilities &&
                        formik.errors.otherLiabilities
                        ? "border-red-500"
                        : "border-gray-light"
                    }
                    className={` sm:h-[36px] h-[32px]    border ${formik.touched.otherLiabilities &&
                      formik.errors.otherLiabilities
                      ? "border-danger"
                      : "border-gray-light"
                      }  flex items-center py-[7.5px] rounded-[6px] focus:outline-none mt-0 px-[8px] sm:px-[12px] sm:w-[170px] w-[140px]`}
                  />
                  {formik.touched.otherLiabilities &&
                    formik.errors.otherLiabilities && (
                      <div className="text-danger text-[12px] text-center sm:text-[13px] mt-1">
                        {formik.errors.otherLiabilities}
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="mt-[10px]">
              <Button type="submit" className="w-full">
                {textData.calculate}
              </Button>
            </div>
          </form>
        </div>
      </CalculatorLayout>
    </>
  );
};

export default NetWorthcalc;
